module.exports = __webpack_public_path__ + "img/message-dark.d9795540.svg";